import { PlanDetails } from '../containers/plans/types';
import { InstructionVideoItem, PlanListItem, ResourceListItem } from '../types';
import {api} from './api';
import qs from 'qs';

export const plansApi = api.injectEndpoints({
	endpoints: (builder) => ({
		plansListPublicQuery: builder.query<PlanListItem[], {tags: string[], countryCode: string, where?: any}>({
			query: (args) => ({
				url: `plans/listPublic?${qs.stringify(args)}`,
				method: 'GET',
			}),
		}),
		plansListByCompanyId: builder.query<PlanListItem[], {companyId: number, countryCode: string}>({
			query: ({companyId, countryCode}) => ({
				url: `plans/listByCompanyId/${companyId}?countryCode=${countryCode}`,
				method: 'GET',
			}),
		}),
		plansList: builder.mutation({
			query: () => ({
				url: 'plans/list',
				method: 'GET',
			}),
		}),
		planGetInfoQuery: builder.query<PlanDetails, {id: string, countryCode: string}>({
			query: ({id, countryCode}) => ({
				url: `plans/${id}/info?countryCode=${countryCode}`,
				method: 'GET',
			}),
			providesTags: ['PlanInfo'],
		}),
		planGetInfo: builder.mutation<PlanDetails, string>({
			query: (id: string) => ({
				url: `plans/${id}/info`,
				method: 'GET',
			}),
		}),
		planGetInfoPublicWithPassword: builder.mutation({
			query: ({id, password}: {id: string, password: string}) => ({
				url: `plans/${id}/infoPublic`,
				method: 'POST',
				body: {password},
			}),
		}),
		planGetInfoPublicQuery: builder.query({
			query: ({id, countryCode}: {id: string, countryCode: string}) => ({
				url: `plans/${id}/infoPublic?countryCode=${countryCode}`,
				method: 'GET',
			}),
		}),
		loadFavourites: builder.query<{id: number}[], void>({
			query: () => ({
				url: 'favourites',
				method: 'GET',
			}),
			extraOptions: { maxRetries: 1 },
			providesTags: ['Favourites'],
		}),
		addFavourite: builder.mutation<PlanListItem, {planId: number}>({
			query: (data) => ({
				url: 'favourites',
				method: 'POST',
				body: data,
			}),
			extraOptions: { maxRetries: 1 },
			invalidatesTags: ['Favourites'],
		}),
		removeFavourite: builder.mutation<number, number>({
			query: (planId: number) => ({
				url: `favourites/${planId}`,
				method: 'DELETE',
			}),
			extraOptions: { maxRetries: 1 },
			invalidatesTags: ['Favourites'],
		}),
		planCreate: builder.mutation<PlanListItem, { title: string, description: string }>({
			query: (data) => ({
				url: 'plans/add',
				method: 'POST',
				body: data,
			}),
		}),
		planUpdate: builder.mutation({
			query: ({id, ...data}) => ({
				url: `plans/${id}`,
				method: 'PUT',
				body: data,
			}),
			invalidatesTags: ['PlanInfo'],
		}),
		planDelete: builder.mutation({
			query: (planId: number) => ({
				url: `plans/${planId}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['PlanInfo'],
		}),
		planPublish: builder.mutation<void, number>({
			query: (planId) => ({
				url: `plans/${planId}/publish`,
				method: 'PUT',
			}),
			extraOptions: { maxRetries: 1 },
			invalidatesTags: ['PlanInfo'],
		}),
		planUnpublish: builder.mutation<void, number>({
			query: (planId) => ({
				url: `plans/${planId}/unpublish`,
				method: 'PUT',
			}),
			extraOptions: { maxRetries: 1 },
			invalidatesTags: ['PlanInfo'],
		}),
		planResourceAdd: builder.mutation<ResourceListItem, Partial<ResourceListItem> & {planId: number}>({
			query: (data) => ({
				url: `plans/${data.planId}/addResource`,
				method: 'POST',
				body: data,
			}),
			extraOptions: { maxRetries: 1 },
			invalidatesTags: ['PlanInfo'],
		}),
		planVideoUpload: builder.mutation<InstructionVideoItem, {id: number, formData: FormData}>({
			query: (data) => ({
				url: `plans/${data.id}/uploadVideo`,
				method: 'POST',
				body: data.formData,
			}),
			invalidatesTags: ['PlanInfo'],
		}),
		planVideoDelete: builder.mutation<Pick<InstructionVideoItem, 'id'>, number>({
			query: (videoId) => ({
				url: `planVideos/${videoId}`,
				method: 'DELETE',
			}),
			extraOptions: { maxRetries: 1 },
			invalidatesTags: ['PlanInfo'],
		}),
	}),
});

export const { usePlansListPublicQueryQuery: usePlansListPublicQuery, usePlanGetInfoQueryQuery: usePlanGetInfoQuery, usePlanGetInfoMutation, useLoadFavouritesQuery, useAddFavouriteMutation, useRemoveFavouriteMutation, usePlansListMutation, usePlanUpdateMutation, usePlanPublishMutation, usePlanUnpublishMutation, usePlanDeleteMutation, usePlanGetInfoPublicQueryQuery: usePlanGetInfoPublicQuery, usePlanResourceAddMutation, usePlanCreateMutation, usePlanVideoUploadMutation, usePlanVideoDeleteMutation, usePlanGetInfoPublicWithPasswordMutation, usePlansListByCompanyIdQuery } = plansApi;
